import React from "react";
import "./Team.scss";

export default function Team() {
  return (
    <section className="page-team">
      {/* Breadcrumb section */}
      <div className="breadcrumb-section">
        <div className="container">
          <div className="breadcrumb-title text-center">Teams</div>
        </div>
      </div>

      <div className="team-section">
        <div className="container">
          <div className="section-subtitle">
            <i className="fas fa-star-of-life"></i> Meet the hearts behind
            Chicago Hajj &amp; Umrah
          </div>

          <div className="team-grid">
            <div className="team-card">
              <div className="card-img">
                <img
                  src="https://chicago-hajj-umrah.s3.us-east-1.amazonaws.com/team/shariq_shahab.jpeg"
                  alt="Shariq Shahab"
                />
              </div>
              <div className="card-content">
                <h3 className="team-name">Shariq Shahab</h3>
                <span className="team-role">Senior Software Engineer</span>
                {/* <p className="team-bio">
                  Over 30 years of guiding Hajj &amp; Umrah expeditions. A
                  visionary who built trust with 30,000+ pilgrims, ensuring
                  religious accuracy and luxury service.
                </p>
                <div className="social-links">
                  <a href="#" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#" aria-label="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="mailto:info@chicagohajj.com" aria-label="Email">
                    <i className="fas fa-envelope"></i>
                  </a>
                </div> */}
              </div>
            </div>

            <div className="team-card">
              <div className="card-img">
                <img
                  src="https://chicago-hajj-umrah.s3.us-east-1.amazonaws.com/team/alnoor_ali.jpeg"
                  alt="Alnoor Ali"
                />
              </div>
              <div className="card-content">
                <h3 className="team-name">Alnoor Ali</h3>
                <span className="team-role">Software Engineer</span>
                {/* <p className="team-bio">
                  Orchestrates 5-star accommodations, high-speed Haramain train
                  logistics, and 24/7 ground staff to ensure flawless pilgrimage
                  experiences.
                </p>
                <div className="social-links">
                  <a href="#" aria-label="LinkedIn">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a href="#" aria-label="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="tel:+13128902882" aria-label="Phone">
                    <i className="fas fa-phone-alt"></i>
                  </a>
                </div> */}
              </div>
            </div>

            <div className="team-card">
              <div className="card-img">
                <img
                  src="https://chicago-hajj-umrah.s3.us-east-1.amazonaws.com/team/bahadur.png"
                  alt="Bahadur Oad"
                />
              </div>
              <div className="card-content">
                <h3 className="team-name">Bahadur Oad</h3>
                <span className="team-role">Software Architect</span>
                {/* <p className="team-bio">
                  Specialist in Tourist &amp; Hajj E-Visa from USA. Streamlined
                  process for 90-day multiple entries. Fast track your spiritual
                  journey approvals.
                </p>
                <div className="social-links">
                  <a href="#" aria-label="WhatsApp">
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  <a href="#" aria-label="Schedule">
                    <i className="far fa-clock"></i>
                  </a>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
